import React, {useEffect, useState} from 'react';
import '../../assets/scss/page/frequently-asked-questions-page-style.scss';
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import parse from "html-react-parser";
import arrow from 'assets/images/arrow.svg';
import HeaderSimpleComponent from "../../component/base/header-component/HeaderSimpleComponent";
import {setSimulationNumber} from '../../util/SimulationManager';

const FrequentlyAskedQuestionsPage = (props) => {
    const {t, i18n} = props.props;
    const simulationNumber = setSimulationNumber();
    const [open, setOpen] = useState([]);

    let questionsTT = [
        {title: t('frequently_asked_question.q01'), content: t('frequently_asked_question.a01')},
        {title: t('frequently_asked_question.q02'), content: t('frequently_asked_question.a02')},
        {title: t('frequently_asked_question.q03'), content: t('frequently_asked_question.a03')},
        {title: t('frequently_asked_question.q04'), content: t('frequently_asked_question.a04')},
        {title: t('frequently_asked_question.q05'), content: t('frequently_asked_question.a05')},
        {title: t('frequently_asked_question.q06'), content: t('frequently_asked_question.a06')},
        {title: t('frequently_asked_question.q07'), content: t('frequently_asked_question.a07')},
        {title: t('frequently_asked_question.q08'), content: t('frequently_asked_question.a08')},
        {title: t('frequently_asked_question.q09'), content: t('frequently_asked_question.a09')},
        {title: t('frequently_asked_question.q10'), content: t('frequently_asked_question.a10')},
        {title: t('frequently_asked_question.q11'), content: t('frequently_asked_question.a11')},
        {title: t('frequently_asked_question.q12'), content: t('frequently_asked_question.a12')},
        {title: t('frequently_asked_question.q13'), content: t('frequently_asked_question.a13')},
        {title: t('frequently_asked_question.q14'), content: t('frequently_asked_question.a14')},
        {title: t('frequently_asked_question.q15'), content: t('frequently_asked_question.a15')}
    ];

    useEffect(() => {
        setQuestions(questionsTT);
    }, [i18n.language]);

    useEffect(() => {
        simulationNumber(9, 4);
    })

    const [questions, setQuestions] = useState(questionsTT);

    const render = () => {
        return questions.map((value, index) => {
            return (
                <div key={index} className="frequently-root">
                    <div className="frequently-question" onClick={() => {
                        let arr = JSON.parse(JSON.stringify(open));
                        if (arr.includes(index)) {
                            let ind = arr.indexOf(index);
                            arr.splice(ind, 1);
                        } else arr.push(index);
                        setOpen(arr)
                    }}>
                        <img src={arrow}
                             className={"frequently-question-index " + (open.includes(index) ? 'frequently-question-index-rotate' : '')}
                             alt="number"/>
                        <p>{value.title}</p>
                    </div>
                    {open.includes(index) && (
                        <p className="frequently-content">{parse(value.content.replaceAll("\n", "<br/><br/>"))}</p>
                    )}
                </div>
            );
        })
    }

    return (
        <div>
            <HeaderSimpleComponent title={t('frequently_asked_question.title')}/>

            <div className="content-root">

                {render()}

                {/*<p onClick={() => navigate(-1)} className="cancel">{t('return_home')}</p>*/}

            </div>

            <FooterComponent/>

        </div>
    );
};

export default FrequentlyAskedQuestionsPage;

